import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheControlService {
  
  public reloadWithCacheBust() {
    const timestamp = new Date().getTime();
    const currentUrl = window.location.href;
    // Remove any existing 'n' parameter
    const baseUrl = currentUrl.split('?')[0];
    window.location.href = `${baseUrl}?n=${timestamp}`;
  }

  public clearLocalCache() {
    // Clear browser storage
    localStorage.removeItem('app_cache');
    sessionStorage.clear();
  }
} 